export class RulesState {
    static InitialFlags = {
        hasFinance: false,
        hasMileage: false,
        hasMpg: false,
        hasPrice: false,
        isPriceOnly: false,
        isSpecialPriceBand: false, // 15, 20 or 25k
        priceBandMaxValue: 0,
        isFreeDelivery: false,
        isMultiMake: false,
        isMultiModel: false,
        isNoMake: false,
        isNoModels: false,
        isSingleModel: false,
        isAllModels: false,
        isMultiBodyStyle: false,
        hasPagination: false,
        hasSort: false,
        hasAttributes: false,
        nonTaxonomyPoints: 0,
        optionsPoints: 0,
        featuresPoints: 0,
        colorsPoints: 0,
        trimsPoints: 0,
        locationPoints: 0,
        hasCvnaid: false,
        hasTextSearchInput: false,
        hasTagIds: false
    };

    static mergeFlags = flags => {
        return {...RulesState.InitialFlags, ...flags};
    };


    constructor(config) {
        this.config = config;

        this.flags = {...RulesState.InitialFlags};

        this.crumbs = {
            previousFilters: {}
        };
        this.meta = {
        };
        this.modifiedCylinderCounts = [];

        this.hasTaxonomy = () => this.flags.isAllModels || this.flags.isMultiModel || this.flags.isSingleModel || this.flags.isMultiMake;

        const cvnaidCausedByFlag = flags => flags.isMultiBodyStyle
            || flags.isMultiModel
            || flags.isMultiMake
            || flags.hasFinance
            || flags.hasPrice
            || flags.hasMileage
            || flags.hasMpg
            || flags.hasPagination
            || flags.hasSort
            || flags.hasAttributes
            || flags.hasTextSearchInput
            || flags.isFreeDelivery
            || flags.hasTagIds;

        this.requiresCvnaid = () => (
            this.flags.nonTaxonomyPoints > 4
                || this.flags.optionsPoints > 2
                || this.flags.featuresPoints > 2
                || this.flags.colorsPoints > 2
                || this.flags.trimsPoints > 2
                || this.flags.locationPoints > 1
                || cvnaidCausedByFlag(this.flags)
        );
    }
}
